var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomePageEventCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 333,
    height: 466,
    viewBox: "0 0 333 466",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M327.844 12.3154C330.622 14.4096 332.42 17.7368 332.42 21.4844V454.113C332.42 460.451 327.282 465.589 320.944 465.589H20.7061C16.8016 465.589 13.355 463.637 11.2822 460.658L4 453.083L9.23047 452.479V21.4844C9.23068 15.1469 14.3685 10.0089 20.7061 10.0088H319.851V4L327.844 12.3154ZM116.303 31.043C108.542 31.043 102.251 37.3343 102.251 45.0947C102.251 52.8553 108.542 59.1465 116.303 59.1465H234.571C242.332 59.1464 248.623 52.8552 248.623 45.0947C248.623 37.3343 242.332 31.0431 234.571 31.043H116.303Z",
    fill: "#FF9999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M311.714 0C318.051 0.000236842 323.189 5.13796 323.189 11.4756V444.104C323.189 450.442 318.051 455.58 311.714 455.58H11.4756C5.13788 455.58 0.000112998 450.442 0 444.104V11.4756C0 5.13781 5.13781 0 11.4756 0H311.714ZM103.046 24.5908C95.2854 24.5908 88.9941 30.882 88.9941 38.6426C88.9944 46.4029 95.2855 52.6943 103.046 52.6943H221.314C229.075 52.6943 235.366 46.4029 235.366 38.6426C235.366 30.8821 229.075 24.5909 221.314 24.5908H103.046Z",
    fill: "#FFDD55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePageEventCard);
export default __webpack_public_path__ + "static/media/HomePage_eventCard.bc21f8ab6b04f8e7228f6aa3d60a9199.svg";
export { ForwardRef as ReactComponent };